import { PortalTasks } from "../../../../../const/portal/PortalTaskConsts";

export const ReportsMenu = {
  dashboard: {
    authorize: {
      hasTaskPrefix: "REPORT.",
    },
    icon: "report",
    title: "REPORTS",
    to: "/app/reports/dashboard",
    source: "/app/reports/",
  },
  menu: [],
};
